.modal {
	:global(.modal-dialog) {
		max-width: 900px;
	}

	:global(.modal-content) {
		border-radius: 12px;
		border: none;
	}

	:global(.modal-header) {
		border-bottom: 1px solid #e5e7eb;
		padding: 1.25rem 1.5rem;
		background: #f9fafb;
		border-radius: 12px 12px 0 0;

		:global(.modal-title) {
			font-size: 1.125rem;
			font-weight: 600;
			color: #111827;
			display: flex;
			align-items: center;
			gap: 0.5rem;
		}
	}

	:global(.modal-body) {
		padding: 1.5rem;
		max-height: 70vh;
		overflow-y: auto;

		&::-webkit-scrollbar {
			width: 8px;
		}

		&::-webkit-scrollbar-track {
			background: #f1f1f1;
			border-radius: 10px;
		}

		&::-webkit-scrollbar-thumb {
			background: #d1d5db;
			border-radius: 10px;

			&:hover {
				background: #9ca3af;
			}
		}
	}

	:global(.modal-footer) {
		border-top: 1px solid #e5e7eb;
		padding: 1rem 1.5rem;
		background: #f9fafb;
		border-radius: 0 0 12px 12px;
		display: flex;
		gap: 0.75rem;
		justify-content: space-between;
	}
}

.description {
	font-size: 0.875rem;
	color: #6b7280;
	margin-bottom: 1.5rem;
	line-height: 1.5;
}

.previewContainer {
	border: 2px solid #e5e7eb;
	border-radius: 12px;
	background: white;
	overflow: hidden;

	:global(table) {
		width: 100%;
		border-collapse: collapse;
		font-size: 0.875rem;

		:global(th),
		:global(td) {
			padding: 0.75rem 1rem;
			text-align: left;
			border: 1px solid #e5e7eb;
		}

		:global(th) {
			background: #f9fafb;
			font-weight: 600;
			color: #374151;
			font-size: 0.8125rem;
			text-transform: uppercase;
			letter-spacing: 0.025em;
		}

		:global(td) {
			color: #111827;
		}

		:global(h2),
		:global(h3) {
			color: #111827;
			margin: 1.5rem 0 1rem;
		}

		:global(h2) {
			font-size: 1.25rem;
			font-weight: 700;
			text-align: center;
		}

		:global(h3) {
			font-size: 1rem;
			font-weight: 600;
		}

		:global(p) {
			margin: 0.5rem 0;
			color: #374151;
			line-height: 1.6;
		}

		:global(strong) {
			font-weight: 600;
			color: #111827;
		}
	}
}

.destinationInfo {
	margin-top: 1.5rem;
	padding: 1rem;
	background: #eff6ff;
	border: 1px solid #bfdbfe;
	border-radius: 8px;
}

.destinationTitle {
	font-size: 0.8125rem;
	font-weight: 600;
	color: #1e40af;
	margin-bottom: 0.375rem;
	text-transform: uppercase;
	letter-spacing: 0.025em;
}

.destinationText {
	font-size: 0.875rem;
	color: #1e3a8a;
	line-height: 1.5;
}

.actions {
	display: flex;
	gap: 0.75rem;
}

.btnBack {
	padding: 0.625rem 1.25rem;
	border-radius: 8px;
	border: 1px solid #d1d5db;
	background: white;
	color: #374151;
	font-size: 0.875rem;
	font-weight: 500;
	cursor: pointer;
	transition: all 0.2s ease;
	display: flex;
	align-items: center;
	gap: 0.5rem;

	&:hover {
		background: #f9fafb;
		border-color: #9ca3af;
	}

	svg {
		width: 16px;
		height: 16px;
	}
}

.btnCancel {
	padding: 0.625rem 1.25rem;
	border-radius: 8px;
	border: 1px solid #d1d5db;
	background: white;
	color: #374151;
	font-size: 0.875rem;
	font-weight: 500;
	cursor: pointer;
	transition: all 0.2s ease;

	&:hover {
		background: #f9fafb;
		border-color: #9ca3af;
	}
}

.btnSend {
	padding: 0.625rem 1.5rem;
	border-radius: 8px;
	border: none;
	background: #84bd44;
	color: white;
	font-size: 0.875rem;
	font-weight: 500;
	cursor: pointer;
	transition: all 0.2s ease;
	display: flex;
	align-items: center;
	gap: 0.5rem;

	&:hover {
		background: #71a438;
	}

	&:disabled {
		opacity: 0.6;
		cursor: not-allowed;

		&:hover {
			background: #84bd44;
		}
	}

	svg {
		width: 16px;
		height: 16px;
	}
}
